import React from 'react';
import Dialog from '@mui/material/Dialog';
import StudentHeader from './components/studentsProfile/StudentHeader';
import StudentInformation from './components/studentsProfile/StudentInformation';
import StudentDetails from './components/studentDetails/StudentDetails';
import { DialogStyleBox } from 'components/Ui/styled';
import { showBackdropLoader, getDialogHeading } from 'utils/commonUtils';
import { DialogStyle } from 'constants';
import ParentContactInfo from './components/studentsProfile/ParentContactInfo';

const StudentProfileDialog = (props) => {
  const { open, setOpen, loading } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {loading ? (
        showBackdropLoader(loading)
      ) : (
        <>
          <Dialog open={open} PaperProps={DialogStyle}>
            {getDialogHeading('Student Profile', handleClose)}
            <DialogStyleBox>
              <StudentHeader />
              <StudentInformation />
              <StudentDetails />
              <ParentContactInfo />
            </DialogStyleBox>
          </Dialog>
        </>
      )}
    </>
  );
};

export default StudentProfileDialog;
